import { render } from "./PR36-02272024.vue?vue&type=template&id=49b28b4e"
import script from "./PR36-02272024.vue?vue&type=script&lang=js"
export * from "./PR36-02272024.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__